(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ergonomic-features"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
    const featureList = document.getElementById('featureList');
    const featureItems = featureList.querySelectorAll('.feature-item');
    const imageWrapper = document.getElementById('ergonomicImageWrapper');
    const prevButton = document.getElementById('sliderPrev');
    const nextButton = document.getElementById('sliderNext');
    const pagination = document.getElementById('imagePagination');
    
    let currentIndex = 0;
    const totalSlides = featureItems.length;

    function loadFeatureImage(picture) {
        if (!picture || picture.dataset.loaded === 'true') return;

        picture.querySelectorAll('source[data-srcset]').forEach(source => {
            source.srcset = source.dataset.srcset;
            source.removeAttribute('data-srcset');
        });

        const img = picture.querySelector('img[data-src]');
        if (img) {
            img.src = img.dataset.src;
            img.removeAttribute('data-src');
        }

        const imgWithSrcset = picture.querySelector('img[data-srcset]');
        if (imgWithSrcset) {
            imgWithSrcset.srcset = imgWithSrcset.dataset.srcset;
            imgWithSrcset.removeAttribute('data-srcset');
        }

        picture.dataset.loaded = 'true';
    }

    function updateArrowVisibility() {
        if (window.innerWidth <= 768) {
            // Remove all hidden logic, ensure both buttons are always visible
            prevButton.classList.remove('hidden');
            nextButton.classList.remove('hidden');
        }
    }

    function activateFeature(index) {
        currentIndex = index;
        
        featureItems.forEach(item => item.classList.remove('active'));
        imageWrapper.querySelectorAll('.ergonomic-features__picture').forEach(picture => picture.classList.remove('active'));
        pagination.querySelectorAll('.pagination-dot').forEach(dot => dot.classList.remove('active'));

        const currentFeature = featureItems[index];
        if (currentFeature) {
            currentFeature.classList.add('active');
            const blockId = currentFeature.className.match(/js-feature-item-([^\s]+)/)[1];
            
            const featureImage = imageWrapper.querySelector(`.js-feature-image-${blockId}`);
            loadFeatureImage(featureImage);
            featureImage?.classList.add('active');

            const paginationDot = pagination.querySelector(`.js-pagination-dot-${blockId}`);
            paginationDot?.classList.add('active');
        }

        updateArrowVisibility();
    }

    if (totalSlides > 0) {
        activateFeature(0);
    }

    featureItems.forEach((item, idx) => {
        item.querySelector('.feature-header').addEventListener('click', () => activateFeature(idx));
    });

    // Modify prevButton to support looping to the last slide
    prevButton.addEventListener('click', () => {
        if (currentIndex > 0) {
            activateFeature(currentIndex - 1);
        } else {
            activateFeature(totalSlides - 1); // Switch to last slide when at first slide
        }
    });

    // nextButton already supports looping to first slide
    nextButton.addEventListener('click', () => {
        if (currentIndex < totalSlides - 1) {
            activateFeature(currentIndex + 1);
        } else {
            activateFeature(0);
        }
    });

    pagination.querySelectorAll('.pagination-dot').forEach((dot, idx) => {
        dot.addEventListener('click', () => activateFeature(idx));
    });

    window.addEventListener('resize', updateArrowVisibility);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // Theme Editor settings can remove optional header children; guard every lookup.
    this.header = this.closest('.section-header');
    if (!this.header) return;

    this.headerIsAlwaysSticky =
      this.getAttribute('data-sticky-type') === 'always' ||
      this.getAttribute('data-sticky-type') === 'reduce-logo-size';
    this.headerBounds = { top: 0, bottom: 0 };
    this.searchModal = this.querySelector('details-modal') || this.header.querySelector('details-modal');
    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.preventHide = false;
    this.predictiveSearch = this.querySelector('predictive-search');

    this.setHeaderHeightHandler = this.setHeaderHeight.bind(this);
    this.setHeaderHeight();

    this.headerMediaQuery = window.matchMedia('(max-width: 990px)');
    this.headerMediaQuery.addEventListener('change', this.setHeaderHeightHandler);

    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky');
    }

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();
  }

  setHeaderHeight() {
    if (!this.header) return;
    document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
  }

  disconnectedCallback() {
    if (this.hideHeaderOnScrollUp) {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    }
    if (this.onScrollHandler) {
      window.removeEventListener('scroll', this.onScrollHandler);
    }
    if (this.headerMediaQuery && this.setHeaderHeightHandler) {
      this.headerMediaQuery.removeEventListener('change', this.setHeaderHeightHandler);
    }
    if (this.headerObserver) {
      this.headerObserver.disconnect();
    }
  }

  createObserver() {
    if (!this.header) return;

    this.headerObserver = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });
    this.headerObserver.observe(this.header);
  }

  onScroll() {
    if (!this.header) return;

    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

    if (scrollTop > 0) {
      this.header.classList.add('header-scrolled-style');
    } else {
      this.header.classList.remove('header-scrolled-style');
    }

    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (this.preventHide) return;
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);
        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);
        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top) {
      this.header.classList.remove('scrolled-past-header');
      requestAnimationFrame(this.reset.bind(this));
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    if (!this.header || this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    this.closeMenuDisclosure();
    this.closeSearchModal();
  }

  reveal() {
    if (!this.header || this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
  }

  reset() {
    if (!this.header || this.headerIsAlwaysSticky) return;
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }

  closeMenuDisclosure() {
    if (!this.header) return;

    this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
    this.disclosures.forEach((disclosure) => {
      if (typeof disclosure.close === 'function') disclosure.close();
    });
  }

  closeSearchModal() {
    if (this.searchModal && typeof this.searchModal.close === 'function') {
      this.searchModal.close(false);
    }
  }
}

if (!customElements.get('sticky-header')) {
  customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();
})();
